<template>
  <div style="width: 100%">
    <modal name="addDraw" style="z-index: 100000001" :height="'auto'" :width="'100%'">
      <div class="modal-content">
        <div class="buttons-container modal-buttons">
          <button v-on:click="hideModal()" class="btn btn-secondary">Cancelar</button>
          <button v-on:click="onClickOk()" class="btn btn-primary">Confirmar</button>
        </div>
      </div>
    </modal>
    <div v-show="isActive" class="widgetContainer" id="drawID">
      <div class="map-tool-window-header" id="drawIDheader">
        <p class="map-tool-window-header-title">Dibujar</p>
        <div class="map-tool-window-header-actions">
          <button class="control-btn" v-on:click="isHidden = !isHidden">
            <!-- <font-awesome-icon v-if="!isHidden" icon="minus"></font-awesome-icon>
            <font-awesome-icon v-else icon="plus"></font-awesome-icon> -->
                        <svg  v-if="isHidden"
            viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <svg v-else
              viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </button>
          <button class="control-btn" v-on:click="exitDraw()">
            <!-- <font-awesome-icon icon="times"></font-awesome-icon> -->
            <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
          </button>
        </div>
      </div>
      <div class="widgetBody" v-show="!isHidden">
        <p v-if="currentDrawingType" style="margin-bottom: 5px; font-style: italic;">
          Modo: {{ toolNames[currentDrawingType] || currentDrawingType }}
        </p>
        <div class="draw-buttons-grid">
          <button v-on:click="initDraw('Point')" class="btn btn-secondary" title="Dibujar Punto" :class="{'active-tool': currentDrawingType === 'Point'}">
            <font-awesome-icon icon="map-marker-alt" />
          </button>
          <button v-on:click="initDraw('LineString')" class="btn btn-secondary" title="Dibujar Línea" :class="{'active-tool': currentDrawingType === 'LineString'}">
            <font-awesome-icon icon="minus" />
          </button>
          <button v-on:click="initDraw('Polygon')" class="btn btn-secondary" title="Dibujar Polígono" :class="{'active-tool': currentDrawingType === 'Polygon'}">
            <font-awesome-icon icon="draw-polygon" />
          </button>
          <button v-on:click="initDraw('Circle')" class="btn btn-secondary" title="Dibujar Círculo" :class="{'active-tool': currentDrawingType === 'Circle'}">
            <font-awesome-icon icon="circle" />
          </button>
          <button v-on:click="initDraw('Arrow')" class="btn btn-secondary" title="Dibujar Flecha" :class="{'active-tool': currentDrawingType === 'Arrow'}">
            <font-awesome-icon icon="arrow-up" />
          </button>
          <button v-on:click="initDraw('Ellipse')" class="btn btn-secondary" title="Dibujar Elipse" :class="{'active-tool': currentDrawingType === 'Ellipse'}">
            <font-awesome-icon icon="ellipsis-h" />
          </button>
          <button v-on:click="initDraw('Freehand')" class="btn btn-secondary" title="Dibujo Mano Alzada" :class="{'active-tool': currentDrawingType === 'Freehand'}">
            <font-awesome-icon icon="signature" />
          </button>
          <button v-on:click="initDraw('Text')" class="btn btn-secondary" title="Texto" :class="{'active-tool': currentDrawingType === 'Text'}">
            <font-awesome-icon icon="font" />
          </button>
        </div>
        <div class="draw-actions-row">
          <button v-on:click="undoAction()" class="btn btn-secondary" title="Deshacer" :disabled="!canUndo">
            <font-awesome-icon icon="undo" />
          </button>
          <button v-on:click="redoAction()" class="btn btn-secondary" title="Rehacer" :disabled="!canRedo">
            <font-awesome-icon icon="redo" />
          </button>
          <button v-on:click="clearAllDrawings()" class="btn btn-danger" title="Borrar todo" style="flex-grow: 1; margin-left: 5px;">
            <font-awesome-icon icon="trash-alt" /> Borrar todo
          </button>
        </div>
        <div v-if="currentDrawingType" class="interactionConfig">
          <label v-if="currentDrawingType !== 'Text'">Estilo de línea
            <select v-model="drawStyleConfig.lineStyle" @change="debouncedUpdate" class="form-control">
              <option value="Sólida">Sólida</option>
              <option value="Segmentada">Segmentada</option>
              <option value="Punteada">Punteada</option>
            </select>
          </label>
          <label>{{ currentDrawingType === 'Text' ? 'Color de texto' : 'Color de línea' }}
            <input
            type="color"
            v-model="drawStyleConfig.strokeColor"
            @input="debouncedUpdate"
          >
          </label>
          <label>{{ currentDrawingType === 'Text' ? 'Tamaño de fuente' : 'Tamaño de línea' }} ({{drawStyleConfig.strokeWidth}})
            <input
            type="range"
            min="1"
            max="10"
            v-model="drawStyleConfig.strokeWidth"
            @input="debouncedUpdate"
            >
          </label>
          <label v-if="currentDrawingType === 'Point'">Radio de punto ({{drawStyleConfig.pointRadius}})
            <input
            type="range"
            min="5"
            max="30"
            v-model="drawStyleConfig.pointRadius"
            @input="debouncedUpdate"
            >
          </label>
          <template v-if="currentDrawingType !== 'LineString' && currentDrawingType !== 'Freehand' && currentDrawingType !== 'Text'">
            <label>Color de relleno
              <input
              type="color"
              :value="rgbaToHex(drawStyleConfig.fillColor)"
              @input="onFillColorChangeLocal"
              >
            </label>
            <label>Opacidad relleno ({{Math.round(drawStyleConfig.fillOpacity * 100)}}%)
              <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              v-model="drawStyleConfig.fillOpacity"
              @input="debouncedUpdate"
              >
            </label>
          </template>
        </div>
        <div class="io-section">
          <p style="font-weight: bold; margin-bottom: 5px;">Importar / Exportar</p>
          <div class="io-controls">
            <input 
              type="text" 
              v-model="exportFileName" 
              placeholder="Nombre del archivo" 
              class="form-control"
              style="margin-bottom: 5px;"
            >
            <div class="io-buttons">
              <button v-on:click="exportGeoJSON()" class="btn btn-success" title="Exportar a GeoJSON">
                <font-awesome-icon icon="download" /> Exportar
              </button>
              <button v-on:click="triggerImport()" class="btn btn-primary" title="Importar desde GeoJSON">
                <font-awesome-icon icon="upload" /> Importar
              </button>
              <input 
                type="file" 
                ref="fileInput" 
                style="display: none" 
                accept=".geojson,application/json"
                @change="onFileChange"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { draggableDiv } from '@/components/mixin/draggableDiv.js'
import { vuex } from '@/components/mixin/vuex.js'
import { draw } from './draw.js'
import { drawStyle, getStyleFromConfig } from './drawStyle.js'
import { mapService } from '@/services/map/mapService.js'
import GeoJSON from 'ol/format/GeoJSON.js'

export default {
  name: 'draw',
  mixins: [vuex, draggableDiv, draw, drawStyle],
  props: ['isFixed', 'currentMode'],
  data() {
    return {
      map: null,
      isHidden: false,
      currentDrawingType: null,
      debounceTimer: null,
      exportFileName: '',

      drawStyleConfig:{
        strokeColor: '#ff0000',
        strokeWidth: 2,
        fillColor: '#ff0000',
        fillOpacity: 0.2,
        pointRadius: 15,
        lineStyle: 'Sólida',
      },

      configs: {
        'Point': { strokeColor: '#ff0000', strokeWidth: 2, fillColor: '#ff0000', fillOpacity: 0.2, pointRadius: 15, lineStyle: 'Sólida' },
        'LineString': { strokeColor: '#0000ff', strokeWidth: 2, fillColor: '#0000ff', fillOpacity: 0.2, pointRadius: 5, lineStyle: 'Sólida' },
        'Polygon': { strokeColor: '#00ff00', strokeWidth: 2, fillColor: '#00ff00', fillOpacity: 0.2, pointRadius: 5, lineStyle: 'Sólida' },
        'Circle': { strokeColor: '#ffff00', strokeWidth: 2, fillColor: '#ffff00', fillOpacity: 0.2, pointRadius: 5, lineStyle: 'Sólida' },
        'Arrow': { strokeColor: '#ff00ff', strokeWidth: 2, fillColor: '#ff00ff', fillOpacity: 0.2, pointRadius: 5, lineStyle: 'Sólida' },
        'Ellipse': { strokeColor: '#00ffff', strokeWidth: 2, fillColor: '#00ffff', fillOpacity: 0.2, pointRadius: 5, lineStyle: 'Sólida' },
        'Freehand': { strokeColor: '#000000', strokeWidth: 2, fillColor: '#000000', fillOpacity: 0.2, pointRadius: 5, lineStyle: 'Sólida' },
        'Text': { strokeColor: '#000000', strokeWidth: 2, fillColor: '#000000', fillOpacity: 0.2, pointRadius: 10, lineStyle: 'Sólida' },
      },

      toolNames: {
        'Point': 'Punto',
        'LineString': 'Línea',
        'Polygon': 'Polígono',
        'Circle': 'Círculo',
        'Arrow': 'Flecha',
        'Ellipse': 'Elipse',
        'Freehand': 'Mano Alzada',
        'Text': 'Texto'
      }
    }
  },
  methods: {
    debouncedUpdate() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        // Sync local config to persistent configs map
        if (this.currentDrawingType) {
            this.configs[this.currentDrawingType] = { ...this.drawStyleConfig };
        }
        this.updateDrawStyle(this.currentDrawingType);
      }, 100);
    },
    onFillColorChangeLocal(event) {
        this.drawStyleConfig.fillColor = event.target.value;
        this.debouncedUpdate();
    },
    initDraw: function (type) {
      this.initDrawLayer();
      
      // Load per-tool configuration
      if (this.configs[type]) {
          this.drawStyleConfig = { ...this.configs[type] };
      }
      
      this.currentDrawingType = type;
      this.initDrawInteraction(type);
      this.updateDrawStyle(type); // Ensure sketch uses current tool style
      document.body.style.cursor = 'crosshair';
    },
    exitDraw: function () {
      if (this.drawInteraction) {
        this.drawInteraction.abortDrawing();
        this.map.removeInteraction(this.drawInteraction);
        this.drawInteraction = null;
      }
      this.removeHelpTooltip();
      if (this.drawLayer) {
        this.drawLayer.setVisible(false);
      }
      document.body.style.cursor = 'default';
      this.selectMapTool('draw', false)
    },
    onDrawEnd(event){
      let textContent = '';
      if (this.currentDrawingType === 'Text') {
        const content = window.prompt("Ingrese el texto:");
        if (content === null || content.trim() === '') {
          // Cancelled or empty: remove feature immediately
          setTimeout(() => {
            this.drawSource.removeFeature(event.feature);
          }, 0);
          return;
        }
        textContent = content.trim();
        event.feature.set('text', textContent);
      }

      // Save style metadata for Export/Import
      event.feature.set('drawStyleConfig', { ...this.drawStyleConfig });

      // Bake style into feature for immutability
      const staticStyle = getStyleFromConfig(this.drawStyleConfig, textContent);
      event.feature.setStyle(staticStyle);

      // Push to history
      this.pushFeature(event.feature);
    },
    exportGeoJSON() {
      const format = new GeoJSON({
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857'
      });
      const features = this.drawSource.getFeatures();
      if (features.length === 0) {
        alert("No hay dibujos para exportar.");
        return;
      }
      const json = format.writeFeatures(features);
      const blob = new Blob([json], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      
      let name = this.exportFileName.trim();
      if (!name) {
        const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
        name = `dibujos_${date}`;
      }
      
      link.href = url;
      link.download = `${name}.geojson`;
      link.click();
      URL.revokeObjectURL(url);
    },
    triggerImport() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.importGeoJSON(e.target.result);
      };
      reader.readAsText(file);
      event.target.value = ''; // Reset for same file re-import
    },
    importGeoJSON(json) {
      try {
        const format = new GeoJSON({
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857'
        });
        const features = format.readFeatures(json);
        if (features.length === 0) {
          alert("El archivo no contiene dibujos válidos.");
          return;
        }

        this.initDrawLayer(); // Ensure layer exists

        features.forEach(feature => {
          const config = feature.get('drawStyleConfig');
          const text = feature.get('text');
          
          if (config) {
            const style = getStyleFromConfig(config, text);
            feature.setStyle(style);
          }
          
          this.drawSource.addFeature(feature);
          this.pushFeature(feature);
        });
      } catch (e) {
        console.error("Error al importar GeoJSON:", e);
        alert("Error al procesar el archivo. Verifique el formato.");
      }
    }
  },
  computed: {
    isActive: function () {
      return this.mapToolValues('draw').active
    }
  },
  watch: {
    isActive: function (active) {
      if (!active) {
        document.body.style.cursor = 'default';
      }
    }
  },
  mounted: function () {
    this.makeDraggable("drawID");
    this.map = mapService.get();
  },
  beforeDestroy: function () {
    this.exitDraw()
  }
}
</script>

<style scoped>
.draw-buttons-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  margin-bottom: 5px;
}

.draw-actions-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.draw-actions-row button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
}

.draw-buttons-grid button {
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.active-tool {
    background-color: #0D6073 !important;
    color: white !important;
}

.interactionConfig label {
    display: block;
    margin-top: 10px;
    font-size: 0.9em;
}

.interactionConfig input {
    display: block;
    width: 100%;
}

.io-section {
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px solid #ddd;
}

.io-buttons {
  display: flex;
  gap: 5px;
}

.io-buttons button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
</style>